module.exports = __webpack_public_path__ + "img/img009.64ebb4c6.png";